import { array, literal, object, union } from "valibot"
import { baseCatalogueSchema } from "./catalogue"
import { productSchema } from "./product"
import { documentSchema } from "./document"

const childSchema = union([
  productSchema,
  documentSchema,
])

/**
 * Schema for Crystallize folders.
 *
 * @see https://crystallize.com/learn/concepts/pim/folder
 */
export const folderSchema = object({
  ...baseCatalogueSchema.entries,
  type: literal("folder"),
  children: array(childSchema), // TODO: If we at some point have nested folders, this must me made recursive.
})
